module.exports = __webpack_public_path__ + "img/Zapbird.863424f6.png";